import { Avatar, Chip, TableCell, TableRow, Typography, Box } from "@mui/material";

import { Div } from "themes/jumbo/@jumbo/shared";
import { ProjectType } from "./types";
import { getCachedData } from "api/Cache";
import Public from "@mui/icons-material/Public";
import { tss } from "tss-react";
import { useHistory } from 'react-router-dom';

const useStyles = tss.create(() => ({
  ellipsis: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box"
  },
  multiLineEllipsis: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical"
  },
  tableTr: {
    " &:hover": {
      background: 'rgba(0, 0, 0, .05)',
      cursor: 'pointer'
    }
  },
  tableTd: {
    padding: '8px 16px',
    fontSize: '0.813rem',
  }
}));

const ProjectItem = ({ item, index, isDefaultProject }: { item: ProjectType, index: Number, isDefaultProject: boolean }) => {

  const { classes } = useStyles();
  const { ID:projectID, name:projectName = 'Unknown Project', description:projectDescription = '', image = '', thumbnail = '', timezone } = item;
  const data: any = getCachedData();
  var views = data["views"];
  const projectViews = Object.values(views)
    .filter((view: any) => view.project === projectID)
      .sort((a:any, b:any) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
  const viewsImages: any[] = projectViews.filter((view: any) => view.has_thumbnail === "1" && view.thumb);
  let projectImage;

  if (viewsImages.length && !(image || thumbnail)) {
    projectImage = viewsImages[0].thumb;
  }
  const history = useHistory();
  const handleClick = (e: any) => {
      history.push(`/catalog/${projectID}`);
  };

  return (
    <>
      {!index ? (
        <TableRow
          sx={{
            "td:first-of-type": {
              pl: 3,
            },
            "td:last-child": {
              pr: 3,
            },
          }}
        >
          <TableCell className={classes.tableTd}>
            <Typography 
              fontSize={'12px'}
              sx={{
                width: { xs: '100%',  sm: '100%' },
              }}
              variant={'h6'}
              color={'text.secondary'}
              mb={1.5}
              mt={1.5}
              pl={6}
            >
              NAME
            </Typography>
          </TableCell>
          <TableCell 
            className={classes.tableTd}
            sx={{
              width: { xs: 'auto',  sm: 'auto', lg: '65%' },
              flex: { xs: '1', lg: '0 1 auto' },
              display: {xs: 'none', sm: 'none', md: 'table-cell', lg:'table-cell', xl:'table-cell'}
            }}
          >
            <Typography 
              fontSize={'12px'}
              variant={'h6'}
              color={'text.secondary'}
              mb={1.5}
              mt={1.5}
            >
              DESCRIPTION
            </Typography>
          </TableCell>
          <TableCell className={classes.tableTd} sx={{ display: {xs: 'none', sm: 'none', md: 'table-cell', lg:'table-cell', xl:'table-cell'}}}>
            <Typography 
              fontSize={'12px'}
              variant={'h6'}
              color={'text.secondary'}
              mb={1.5}
              mt={1.5}
              textAlign={'center'}
            >
              VIEWS
            </Typography>
          </TableCell>
        </TableRow>
      ) : ""}
      <TableRow
        sx={{
          "td:first-of-type": {
            pl: 3,
          },
          "td:last-child": {
            pr: 3,
          },
        }}
        className={classes.tableTr}
        onClick={handleClick}
      >
        <TableCell className={classes.tableTd}>
          <Div sx={{ display: "flex", minWidth: 0, alignItems: "center" }}>
            <Avatar
                sx={{ width: "30px", height: "30px", mr: 2, bgcolor: 'rgba(32,32,32,.05)', borderRadius: '50%' }}
                alt={item.name}
                src={projectImage}
                variant='rounded'
            >
              {!projectImage ? <Public style={{ color: 'rgba(2, 87, 142, .45)', width: '100%', height: '100%' }} /> : ""}
            </Avatar>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2" fontSize={14} sx={{ lineHeight: 1 }}>
                {projectName}
              </Typography>

              {isDefaultProject && (
                <Typography variant="body2" fontSize={14} color="rgba(61,171,230,.95)" sx={{ lineHeight: 1 }}>
                  Demo
                </Typography>
              )}
            </Box>
          </Div>
        </TableCell>
        <TableCell className={classes.tableTd} sx={{ display: {xs: 'none', sm: 'none', md: 'table-cell', lg:'table-cell', xl:'table-cell'}}}>
          <Typography variant={'body1'} className={classes.multiLineEllipsis} fontSize={12}>{projectDescription || '---' }</Typography>
        </TableCell>
        <TableCell className={classes.tableTd} sx={{ display: {xs: 'none', sm: 'none', md: 'table-cell', lg:'table-cell', xl:'table-cell'}}}>
          <Typography variant={'body1'} fontSize={'11px'} color={'text.secondary'} textAlign={'center'} sx={{ display: {xs: 'none', sm: 'none', lg:'table-cell', xl:'table-cell'}}}>{projectViews.length}</Typography>
        </TableCell>
      </TableRow>
    </>
  );
};
const EmptyProjectItem = () => {

  const { classes } = useStyles();
  return (
    <TableRow
      sx={{
        "td:first-of-type": {
          pl: 3,
        },
        "td:last-child": {
          pr: 3,
        },
      }}
    >
      <TableCell colSpan={3}>
        <Div>
          <Typography
              fontSize={'13px'}
              variant={'body1'}
              color={'text.secondary'}
              sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '50px 0', height: '323px'}}
          >
              No Project found
          </Typography>
        </Div>
      </TableCell>
    </TableRow>
  );
};
export { ProjectItem, EmptyProjectItem };
